import { API } from "aws-amplify";
import { getLease } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_LEASE_INFO: APITypes.Lease = {
  id: "",
  tenantID: "",
  entityID: "",
  startDate: "",
  endDate: "",
  markedDate: "",
  type: APITypes.LeaseTypeOptions.OneYear,
  status: APITypes.LeaseStatusType.Active,
  extraOccupants: [],
  applicationID: "",
  backgroundCheckID: "",
  moveInID: "",
  moveOutID: "",
  offerID: "",
  __typename: "Lease",
  createdAt: "",
  updatedAt: "",
  nextLeaseID: "",
  prevLeaseID: "",
  entityType: APITypes.EntityType.Property,
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getLeaseInfo = async (
  leaseID: string
): Promise<LoaderData<APITypes.Lease>> => {
  try {
    const response = (await API.graphql({
      query: getLease,
      variables: {
        id: leaseID,
      },
    })) as { data?: APITypes.GetLeaseQuery };

    return {
      success: true,
      data: response.data?.getLease || EMPTY_LEASE_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_LEASE_INFO,
      error,
    };
  }
};
